define('entities/chat_inbox',[
  'app',
  'jquery',
  'underscore',
  'backbone',
  'settings',
  'backboneRelational'
], function (App, $, _, Backbone, Settings) {
  'use strict';

  var app;
  if (Backbone.Relational.store._modelScopes && Backbone.Relational.store._modelScopes.length > 0) {
    app = { ns: Backbone.Relational.store._modelScopes[0] };
  } else {
    app = { ns: {} };
    Backbone.Relational.store.addModelScope(app.ns);
  }

  app.ns.ChatSession = Backbone.RelationalModel.extend({
    defaults: {
      secId: null,
      sessionId: null,
      senderEmail: '',
      senderName: '',
      customerSecId: null,
      customerName: '',
      pageUrl: null,
      ipAddress: null,
      ipBanned: false,
      locale: null,
      status: 'WAITING_HUMAN',
      assignedUserpidSecId: null,
      assignedUserpidName: '',
      assignedGroupSecId: null,
      assignedGroupName: '',
      online: false,
      fileUploadEnabled: false,
      startedAt: null,
      lastCustomerMessageAt: null,
      lastAgentMessageAt: null,
      firstHumanResponseAt: null,
      claimedAt: null,
      resolvedAt: null
    },
    idAttribute: 'secId'
  });

  // Keep one Backbone-Relational instance per secId so the list and detail
  // views share state — a WS update from the chat-message-added handler
  // mutates the same model the list row already binds against, so the row
  // re-renders without a re-fetch.
  App.reqres.setHandler('chatInbox:model', function (json) {
    var existing = null;
    if (json && json.secId) {
      existing = Backbone.Relational.store.find(app.ns.ChatSession, json.secId);
    }
    if (existing) {
      existing.set(json);
      return existing;
    }
    return new app.ns.ChatSession(json);
  });

  var API = {
    listUrl:     function (params) { return Settings.url('compuzz2', 'v2/chat-inbox', params); },
    rowCountUrl: function (params) { return Settings.url('compuzz2', 'v2/chat-inbox/rowCount', params); },
    countsUrl:   function ()       { return Settings.url('compuzz2', 'v2/chat-inbox/counts'); },
    presenceUrl: function (secId)  { return Settings.url('compuzz2', 'v2/chat-inbox/' + secId + '/presence'); },
    detailUrl:   function (secId)  { return Settings.url('compuzz2', 'v2/chat-inbox/' + secId); },
    deleteUrl:   function (secId)  { return Settings.url('compuzz2', 'v2/chat-inbox/' + secId); },
    claimUrl:   function (secId)  { return Settings.url('compuzz2', 'v2/chat-inbox/' + secId + '/claim'); },
    releaseUrl: function (secId)  { return Settings.url('compuzz2', 'v2/chat-inbox/' + secId + '/release'); },
    resolveUrl: function (secId)  { return Settings.url('compuzz2', 'v2/chat-inbox/' + secId + '/resolve'); },
    reopenUrl:  function (secId)  { return Settings.url('compuzz2', 'v2/chat-inbox/' + secId + '/reopen'); },
    replyUrl:   function (secId)  { return Settings.url('compuzz2', 'v2/chat-inbox/' + secId + '/reply'); },
    fileUploadEnabledUrl: function (secId) { return Settings.url('compuzz2', 'v2/chat-inbox/' + secId + '/file-upload-enabled'); },
    banUrl:     function ()       { return Settings.url('compuzz2', 'v2/chat-inbox/banned-ips'); },
    unbanUrl:   function (ip)     { return Settings.url('compuzz2', 'v2/chat-inbox/banned-ips/' + encodeURIComponent(ip)); }
  };

  App.reqres.setHandler('chatInbox:list-url', API.listUrl);
  App.reqres.setHandler('chatInbox:count-url', API.rowCountUrl);

  // Active-chat counts for the header icon: { unassigned, mine }.
  App.reqres.setHandler('chatInbox:counts', function () {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.countsUrl(),
      success: function (data) { defer.resolve(data || { unassigned: 0, mine: 0 }); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  // Live presence: resolves with a boolean — is the visitor's chat widget
  // currently connected. On any error, resolves false (treat unknown as
  // offline) so the caller never has to branch on failure.
  App.reqres.setHandler('chatInbox:presence', function (secId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.presenceUrl(secId),
      success: function (data) { defer.resolve(!!(data && data.online === true)); },
      error: function () { defer.resolve(false); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('chatInbox:get', function (secId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.detailUrl(secId),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  // Claim returns 409 + the current state of the row when someone else won
  // the race — surface that to the caller so the UI can flash a "Taken by X"
  // toast and refresh the row, rather than a generic error.
  App.reqres.setHandler('chatInbox:claim', function (secId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'POST',
      url: API.claimUrl(secId),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) {
        if (xhr && xhr.status === 409) {
          defer.reject({ raceLost: true, current: xhr.responseJSON });
        } else {
          defer.reject(xhr);
        }
      }
    });
    return defer.promise();
  });

  App.reqres.setHandler('chatInbox:release', function (secId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'POST',
      url: API.releaseUrl(secId),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('chatInbox:resolve', function (secId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'POST',
      url: API.resolveUrl(secId),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('chatInbox:reopen', function (secId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'POST',
      url: API.reopenUrl(secId),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('chatInbox:reply', function (secId, text) {
    var defer = $.Deferred();
    $.ajax({
      type: 'POST',
      url: API.replyUrl(secId),
      contentType: 'application/json',
      data: JSON.stringify({ text: text }),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  // Grant or revoke the visitor's permission to attach files in this chat.
  // Resolves with the updated ChatSession json.
  App.reqres.setHandler('chatInbox:set-file-upload-enabled', function (secId, enabled) {
    var defer = $.Deferred();
    $.ajax({
      type: 'POST',
      url: API.fileUploadEnabledUrl(secId),
      contentType: 'application/json',
      data: JSON.stringify({ enabled: !!enabled }),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  // Permanently delete a chat (session + messages + activity + files).
  App.reqres.setHandler('chatInbox:delete', function (secId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'DELETE',
      url: API.deleteUrl(secId),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  // Ban a visitor's IP from the chat. The backend's ChatBanRequest treats
  // an absent durationMinutes as a permanent ban.
  App.reqres.setHandler('chatInbox:ban', function (ip, reason) {
    var defer = $.Deferred();
    $.ajax({
      type: 'POST',
      url: API.banUrl(),
      contentType: 'application/json',
      data: JSON.stringify({ ip: ip, reason: reason }),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  // Lift an IP ban.
  App.reqres.setHandler('chatInbox:unban', function (ip) {
    var defer = $.Deferred();
    $.ajax({
      type: 'DELETE',
      url: API.unbanUrl(ip),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });
});

